import styled from "@emotion/styled";
import {
  respond,
  buttonUnstyled,
  defaultHoverStyle,
  utilityPrimary,
  fluidScale
} from "theme/styles/mixins";
import { Form as BaseForm } from "global/containers/form/styles";

export const Dialog = styled.dialog`
  padding: ${fluidScale("60px", "30px")};
  padding-block-start: ${fluidScale("50px", "25px")};
  overflow: auto;
  // fallback if dvh units not supported
  max-block-size: 90vh;
  max-block-size: 90dvh;
  inline-size: 88vw;
  max-inline-size: 1000px;
  border-radius: 20px;
  font-family: var(--font-family-sans);
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const Options = styled.fieldset`
  display: flex;
  gap: 40px;
  flex-direction: column;
  max-width: 100%;

  > * {
    flex-basis: 50%;
  }

  ${respond(`flex-direction: row;`, 50)}
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: start;
  color: var(--reader-color);
`;

export const TextColumn = styled.div`
  > * + * {
    margin-block-start: 17px;
  }

  > *:first-child {
    margin-block-start: 0;
  }
`;

export const Instructions = styled.span`
  font-family: var(--font-family-copy);
  font-style: italic;
  font-weight: 400;
`;

export const Form = styled(BaseForm)`
  --Form-row-gap: ${fluidScale("50px", "30px")};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;

  > button {
    min-width: 140px;
  }
`;

export const CloseButton = styled.button`
  ${buttonUnstyled}
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  cursor: pointer;
  padding-inline: 14px;
  ${utilityPrimary}
  font-size: 13px;
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.125em;

  &:hover {
    ${defaultHoverStyle}
    outline: 0;
  }

  &:focus-visible {
    color: var(--focus-color);
  }

  > span {
    margin-block-start: -1px;
  }
`;
